import { Lock, Timer, Scale } from 'lucide-react';
import { Button } from '@nextdone/ui';
import { useTonConnectModal } from '@tonconnect/ui-react';
import { hapticTick } from '../lib/haptics';

const MECHANISMS = [
  { Icon: Lock, head: 'Funds lock first.', sub: 'Money sits in a TON smart contract before work starts.' },
  { Icon: Timer, head: 'Silence means payment.', sub: 'After 72h without a response, escrow auto-releases.' },
  { Icon: Scale, head: 'Disputes are handled.', sub: 'An arbiter splits the stake by the ledger, not by charm.' },
];

/** Entry gate — ledger-speak, hairline structure, one paper CTA that opens TonConnect. */
export function ConnectScreen() {
  const { open } = useTonConnectModal();

  return (
    <div className="min-h-[100dvh] flex flex-col px-gutter py-8">
      {/* Wordmark */}
      <div className="font-mono text-micro font-medium uppercase tracking-label text-fg-1 pb-14">
        NEXTDONE.
      </div>

      <div className="flex-1 flex flex-col justify-center gap-10">
        <h1 className="font-body font-extrabold text-display-xl tracking-display text-fg-1 m-0 [text-wrap:pretty]">
          Work with
          <br />
          certainty.
        </h1>

        <div className="border-t border-hairline">
          {MECHANISMS.map(({ Icon, head, sub }) => (
            <div key={head} className="flex gap-3.5 items-start py-4 border-b border-hairline">
              <span className="text-fg-2 grid flex-none pt-0.5">
                <Icon size={18} strokeWidth={1.75} />
              </span>
              <div>
                <div className="font-body font-bold text-body text-fg-1">{head}</div>
                <div className="font-body text-caption font-medium text-fg-2">{sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-3 pt-10">
        <Button
          block
          size="lg"
          onClick={() => {
            hapticTick();
            open();
          }}
        >
          Open the ledger.
        </Button>
        <div className="font-mono text-micro font-medium uppercase tracking-[0.08em] text-fg-3 text-center leading-[1.6]">
          No KYC. Trust is staked, not claimed.
        </div>
      </div>
    </div>
  );
}
